export const LEGAL_LEDGER_KEY = 'mon-testament-legal';

/** Which version of the terms the owner accepted, and when: on the phone, nothing else. */
export interface LegalAcceptance {
  readonly version: number;
  readonly acceptedAt: string;
}

const isAcceptance = (value: unknown): value is LegalAcceptance =>
  typeof value === 'object' &&
  value !== null &&
  Number.isInteger((value as Record<string, unknown>)['version']) &&
  typeof (value as Record<string, unknown>)['acceptedAt'] === 'string';

/**
 * The acceptance of the terms, kept in local storage like the day of the last backup. A storage
 * that refuses — private browsing, blocked site data — reads as nothing accepted, and the
 * question is simply asked again next time.
 */
export class LegalLedger {
  constructor(private readonly storage: Pick<Storage, 'getItem' | 'setItem'> | undefined) {}

  accepted(): LegalAcceptance | null {
    try {
      const stored = this.storage?.getItem(LEGAL_LEDGER_KEY) ?? null;
      if (stored === null) return null;
      const parsed: unknown = JSON.parse(stored);
      return isAcceptance(parsed) ? parsed : null;
    } catch {
      return null;
    }
  }

  accept(version: number, at: string): void {
    try {
      this.storage?.setItem(LEGAL_LEDGER_KEY, JSON.stringify({ version, acceptedAt: at }));
    } catch {
      // Nothing to do: the owner goes on; the question comes back next time.
    }
  }
}
